import { widget } from "@foretagsplatsen/widgetjs";
import AutoSaveWidget from "./AutoSaveWidget.js";
import loadingWidget from "../widgets/loadingWidget.js";

/**
 * `abstractHeaderWidget` is the common abstract superclass of all header
 * widgets.
 *
 * @param {{}} spec - Parameter object
 * @param {boolean} spec.visible - Boolean to toggle the widget visibility
 * @param {*} my - protected fields holder
 * @return {*}
 */
function abstractHeaderWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);

	my.visible = spec.visible || false;

	my.loading = loadingWidget();
	my.autoSave = new AutoSaveWidget();

	my.document;

	that.onLeftTogglerClick = my.events.createEvent();
	that.onRightTogglerClick = my.events.createEvent();

	that.setDocument = function (newDocument) {
		my.setDocument(newDocument);
	};

	that.getDocument = function () {
		return my.document;
	};

	that.isVisible = function () {
		return true;
	};

	my.renderLoadingOn = function (html) {
		html.render(my.loading);
	};

	my.renderAutoSaveOn = function (html) {
		html.render(my.autoSave);
	};

	my.setDocument = function (newDocument) {
		my.document = newDocument;
		that.update();
	};

	return that;
}

export default abstractHeaderWidget;
